import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder_error_email: {
    id: 'kustomer.chat.conversation.volumeControl.input.email.error',
    description: 'Error copy for volume control email validation',
    defaultMessage: 'Please enter a valid email',
  },
  placeholder_error_phone: {
    id: 'kustomer.chat.conversation.volumeControl.input.phone.error',
    description: 'Error copy for volume control phone validation',
    defaultMessage: 'Please enter a valid phone number',
  },
  placeholder: {
    id: 'kustomer.chat.conversation.volumeControl.input.placeholder',
    description: 'Placeholder for volume control form input',
    defaultMessage: 'Type a message...',
  },
  wait_label: {
    id: 'kustomer.chat.conversation.volumeControl.wait.label',
    description: "Label for 'wait' option",
    defaultMessage: "I'll wait",
  },
  no_avail: {
    id: 'kustomer.chat.conversation.volumeControl.noAvail.message',
    description: "Label for 'wait' option",
    defaultMessage:
      'Sorry, it looks like no one has become available in the time we expected. Please select an alternate contact method for us to follow up with you...',
  },
  no_avail_upfront: {
    id: 'kustomer.chat.conversation.volumeControl.upfront.noAvail.message',
    description: "Label for 'wait' option",
    defaultMessage:
      'Our current wait time is approximately {waitTime}. You can choose to wait for the next available agent or select an alternative contact method for us to follow up with you.',
  },
  channel_message: {
    id: 'kustomer.chat.conversation.volumeControl.channel.message',
    description: "Label for 'wait' option",
    defaultMessage: "Great, what's the best {channelName} to reach you at?",
  },
  thankYou_message: {
    id: 'kustomer.chat.conversation.volumeControl.thankYou.message',
    description: "Label for 'wait' option",
    defaultMessage: "Thank you. We'll get back to you shortly.",
  },
  phone_number: {
    id: 'kustomer.chat.conversation.volumeControl.phoneNumber.message',
    description: "Label for 'wait' option",
    defaultMessage: 'phone number',
  },
  days: {
    id: 'kustomer.chat.conversation.volumeControl.days',
    description: "Label for 'wait' option",
    defaultMessage: 'days',
  },
  hours: {
    id: 'kustomer.chat.conversation.volumeControl.hours',
    description: "Label for 'wait' option",
    defaultMessage: 'hours',
  },
  minutes: {
    id: 'kustomer.chat.conversation.volumeControl.minutes',
    description: "Label for 'wait' option",
    defaultMessage: 'minutes',
  },
  seconds: {
    id: 'kustomer.chat.conversation.volumeControl.seconds.v2',
    description: "Label for 'wait' option",
    defaultMessage: 'under 1 minute',
  },
  aria_label_send_message: {
    id: 'kustomer.chat.conversation.volumeControl.aria.label.send.message',
    description: 'Aria label for send message',
    defaultMessage: 'Send message',
  },
});
